import Message from '../../Message';

export default function getLastMessageFromGroup(messageGroup?: Message[] | Message | null): Message | null {
  if (!messageGroup) {
    return null;
  }

  if(!Array.isArray(messageGroup) && messageGroup instanceof Message) {
    return messageGroup;
  }

  return messageGroup[messageGroup.length - 1] || null;
}